import sortBy from 'lodash/sortBy';
import dayjs from '@/utils/dayjs';

const Altinn = {
  pensionEmploymentType: 'pensjonOgAndreTyperYtelserUtenAnsettelsesforhold',
  freelancerEmploymentType: 'frilanserOppdragstakerHonorarPersonerMm',
  descriptionsRequiringQuantity: [
    'besoeksreiserHjemmetKilometergodtgjoerelseBil',
    'kilometergodtgjoerelseAndreFremkomstmidler',
    'kilometergodtgjoerelseBil',
    'kilometergodtgjoerelseElBil',
    'kilometergodtgjoerelsePassasjertillegg',
    'overtidsgodtgjoerelse',
    'reiseKostMedOvernattingPaaHotell',
    'reiseKostMedOvernattingPaaHybelBrakkePrivat',
    'reiseKostMedOvernattingPaaPensjonat',
    'reiseKostUtenOvernatting',
    'timeloenn',
    'losji',
  ],
};
export default Altinn;

interface ISortableAmelding {
  ameldingReference: string | null;
  altinnSubmission: {
    sentAt: dayjs.Dayjs;
  } | null;
  altinn3Submission: {
    sentAt: dayjs.Dayjs;
  } | null;
  ameldingToReplace: {
    ameldingReference: string | null;
  } | null;
}

// Sort reports by sentAt ASC, and then group them by relevance
export const sortAmeldings = <T extends ISortableAmelding>(reports: T[]): T[] => {
  const reportGroups: T[][] = [];

  sortBy(reports, r => {
    const submission = r.altinnSubmission || r.altinn3Submission!;
    return submission.sentAt.valueOf();
  }).forEach(report => {
    const group = reportGroups.find(g =>
      g.some(r =>
        report.ameldingToReplace?.ameldingReference === r.ameldingReference ||
        r.ameldingToReplace?.ameldingReference === report.ameldingReference,
      ),
    );

    if (group) group.push(report);
    else reportGroups.push([ report ]);
  });

  reportGroups.forEach(g =>
    g.sort((r1, r2) => {
      if (r1.ameldingToReplace?.ameldingReference === r2.ameldingReference) return 1;
      if (r2.ameldingToReplace?.ameldingReference === r1.ameldingReference) return -1;
      return 0;
    }),
  );

  return reportGroups.flat();
};

export interface IFilterableWorkRelation {
  employmentType: string;
  startDate: string;
  endDate?: string;
  endDateSentToAltinn: boolean;
  paychecksForAmelding: Array<unknown>;
}

export const filterWorkRelationsForNewAmelding = (wr: IFilterableWorkRelation, calendarMonth: string): boolean => {
  if (wr.paychecksForAmelding.length > 0) return true; // show them if they have paychecks
  if (wr.employmentType === Altinn.pensionEmploymentType) return false; // hide pension employments

  if (dayjs.strict(wr.startDate).isAfter(calendarMonth, 'month')) return false; // do not show the not yet started workRelations

  if (!wr.endDate) return true;  // show the ones without endDate
  if (dayjs.strict(wr.endDate).isSameOrAfter(calendarMonth, 'month')) return true; // show workRelations until endDate has passed
  if (!wr.endDateSentToAltinn) return true; // show workRelations until endDate has been sent to altinn
  return false;
};
